import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { LoginApi, LoginModel } from '../../shared/_api/login.api';
import { AppApi } from '../../shared/_api/app.api';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';
import { LocalStorage } from "../../shared/_api/localstorage";
import { ToastrService } from 'ngx-toastr';
import { LookupService } from './../../shared/services/lookup.service';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  show: boolean = false;
  loginForm: FormGroup;
  errorMessage: any;
  btnDisabled = false;
  submitted = false;


  constructor(private fb: FormBuilder, public router: Router, private api: LoginApi, private apiapi: AppApi,
    private translate: TranslateService, private toastr: ToastrService,
    private route: ActivatedRoute, private sharedService: SharedHttpService,
    private lookupService: LookupService) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

  login() {

    this.btnDisabled = true;
    if (this.loginForm.valid) {

      this.api.Login(this.loginForm.value as LoginModel).subscribe(result => {
        if (result.access_token != null) {
          LocalStorage.AccessToken = { access_token: result.access_token, refresh_token: result.refresh_token };
          this.sharedService.get('api/Lookup/GetAllLookups').subscribe(res => {
            localStorage.setItem('lookup', JSON.stringify(res));
            this.lookupService.setLockup(res);
          })
          this.getuserdata();
        }
        else {
            this.sharedService.showErrorKey("InvalidCredentials")
          //this.translate.get("").subscribe((text: string) => {
          //  this.toastr.error(text, "");
          //});
        }
      }, error => {
        //this.toastr.error("خطأ في اسم المستخدم أو كلمة المرور", '');
          this.sharedService.showErrorKey("InvalidCredentials")
      }
      );
    }
    else
      this.submitted = true;
    this.btnDisabled = false;

  }
  getuserdata() {
    this.sharedService.get("api/Account/GetUserAuthTicket").subscribe(result => {
        localStorage.setItem('user', JSON.stringify(result)); 

      let returnUrl: any = this.route.snapshot.queryParams['returnUrl'] || '/';
      returnUrl = '/';

      if (returnUrl != null && returnUrl != "") {
        if (returnUrl.indexOf("login") != -1) {
          this.router.navigate(["'/'"]);
        } else
          this.router.navigateByUrl(returnUrl);
      }
      else
        this.router.navigate(["'/'"]);
    });
  }

}
